module.exports = {
  SITE_URL: `https://www.nicaraguasbestguides.com/`,
  SITE_TITLE_ALT: "Best Guides",
  SITE_LOGO_IMG: "nbg.png",
  SITE_SEO_IMG: "default-seo.jpg",
  GOOGLE_TRACKING_ID: `UA-109360203-10`,
}
